const SessionType = [
    {id: 1, name:"Onsite"},
    {id: 2, name:"Online Synchronous"},
    {id: 3, name:"Online Asynchronous"}
]

export {SessionType}